import api, { unwrap } from './client';

// Plan pluriannuel par offre : la vue calculée sur cinq années, et l'écriture d'une cellule.
export const getOfferPlan = (tenantId, year) => unwrap(api.get(`/sales-offer-plan/${tenantId}/${year}`));
export const setOfferPlanCell = (tenantId, offerId, year, payload) =>
  unwrap(api.put(`/sales-offer-plan/${tenantId}/${offerId}/${year}`, payload));
export const setOfferPlanLineOrder = (tenantId, lineIds) =>
  unwrap(api.put(`/sales-offer-plan/${tenantId}/line-order`, { line_ids: lineIds }));
// Les lignes sous une offre (clients, segments, tarifs) : création, renommage, retrait, ordre.
export const addOfferPlanLine = (tenantId, offerId, label) =>
  unwrap(api.post(`/sales-offer-plan/${tenantId}/${offerId}/lines`, { label }));
export const renameOfferPlanLine = (tenantId, lineId, label) =>
  unwrap(api.patch(`/sales-offer-plan/${tenantId}/lines/${lineId}`, { label }));
export const deleteOfferPlanLine = (tenantId, lineId) => unwrap(api.delete(`/sales-offer-plan/${tenantId}/lines/${lineId}`));
export const setOfferPlanLinesOrder = (tenantId, offerId, lineIds) =>
  unwrap(api.put(`/sales-offer-plan/${tenantId}/${offerId}/lines-order`, { line_ids: lineIds }));
